var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cpt-chat-more-loading flex-center h-[50px] w-full relative"},[_c('div',{staticClass:"loading w-[12px] h-[12px]"})])
}]

export { render, staticRenderFns }